import {z} from 'zod';

/**
 * Request schema for getting usage by message ID
 */
export const getUsageRequestSchema = z.object({
  messageId: z.string(),
});

export type GetUsageRequest = z.infer<typeof getUsageRequestSchema>;
